<template>
        <div class="lvl1" ref="menuroot">
            <div class="m1container" :class="{m1only : lvl1==''}">
                <div class="closeMenu btn" v-if="lvl1!=''" @click="closeMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" class="closeIcon" viewBox="0 0 25.944 27.708">
                        <g id="Gruppe_6" data-name="Gruppe 6" transform="translate(-205.028 -605.146)">
                            <line id="Linie_2" data-name="Linie 2" y1="25" x2="23" transform="translate(206.5 606.5)" fill="none" stroke="#fff" stroke-width="4"/>
                            <line id="Linie_3" data-name="Linie 3" x1="23" y1="25" transform="translate(206.5 606.5)" fill="none" stroke="#fff" stroke-width="4"/>
                        </g>
                    </svg>
                </div>
                <MenuButton v-for="value in level1menu" 
                    :title='value.title' 
                    :value='value.value' 
                    :key="value.value" 
                    class="l1 btn"
                    :style="{ backgroundColor: value.color1}"
                    :class="{'l1-activated':(lvl1==value.value)}"
                    @click="clickedLevel1">
                </MenuButton>
            </div>
            <div class="m2container" v-if="lvl1!=''">
                <MenuButton v-for="value in level2menu" 
                    :title='value.title' 
                    :value='value.value' 
                    :key="value.value" 
                    class="l2 btn"
                    :class="{'l2-activated':(lvl2==value.value)}"
                    @click="clickedLevel2">
                </MenuButton>
                <div class="filler"></div>
            </div>
        </div>
</template>
<script>
import MenuButton from './MenuButton.vue'

export default {
    name:'MenuBar',
    components:{MenuButton},
    props:{
        menudata:Object,
    },
    data(){
        return {
            lvl1:'',
            lvl2:'',
            
        }
    },
    computed:{
        level1menu:function(){
            var a = [];
            if(this.lvl1!=''){
                if(this.menudata[this.lvl1]!==undefined)a.push(this.menudata[this.lvl1]);
            }else{
                for(var key in this.menudata){
                    a.push(this.menudata[key]);
                }
            }
            return a;
        },
        level2menu:function(){
            if(this.lvl1===''){
                return [];
            }else{
                if(this.menudata[this.lvl1]!==undefined)return this.menudata[this.lvl1].states;
                return [];
            }
        }
    },
    watch: {
      // whenever lvl1 changes, this function will run
      lvl1(n) {
          if(n!=='' && this.menudata[n]!==undefined){
            // this.$refs.menuroot.style.setProperty('--secondary-color',this.menudata[n].color1);
            document.documentElement.style.setProperty('--m-secondary-color',this.menudata[n].color1);
          }else{
            // this.$refs.menuroot.style.setProperty('--secondary-color','#02b0a4');
            document.documentElement.style.setProperty('--m-secondary-color','#02b0a4');
          }
        this.$emit('changeLvl1',n);
      },
      lvl2(n){
          this.$emit('changeLvl2',n);
      }
    }
    ,
    methods:{
        clickedLevel1: function(val){
            this.lvl1 = val;
        },
        clickedLevel2: function(val){
            this.lvl2 = val;
        },
        closeMenu: function(){
            this.lvl1 = '';
            this.lvl2 = '';
        }
    }
}
</script>
<style scoped>
.lvl1{
    display: flex;
    flex-direction: row;
    width:100%;
    height:100%;
    justify-content: flex-start;
    align-items: stretch;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    background: none;
    /* background-color: var(--secondary-color); */
    /* transition: all 0.6s ease-in-out; */
    pointer-events: none;
}
.m1container{
    background-color: var(--m-secondary-color);
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;
    width:100%;
    flex-basis:650px;
    height:var(--m1-height,100%);
    /* transition: all 0.6s ease-in-out; */
    position: var(--m1-position,inherit);
    top: var(--m1-top,0px);
}
.m1only{
    width:100%;
    flex-basis:100% !important;
}
.m2container{
    background-color: var(--m-secondary-color);
    display: flex;
    flex-direction: row;
    flex-wrap: var(--m2-wrap, nowrap);
    justify-content: stretch;
    align-items: stretch;
    flex-basis:100%;
    width: var(--m2-width,100%);
    height:var(--m2-height,100%);
    /* transition: all 0.6s ease-in-out; */
    position: var(--m2-position,inherit);
    bottom: var(--m2-bottom,0px);
}

.closeMenu{
    color: #fff;
    background-color: none;
    user-select: none;
    cursor: pointer; 
    flex-basis: 100px;   
    flex-grow: 0;
    flex-shrink: 0.5;
    display: flex;
    justify-content: center;
    align-items: center;
    border-width: var(--l1-border,0px 1px 0px 0px);
}
.closeIcon{
    width: var(--close-icon-width, 25px);
    height: var(--close-icon-height, 27px);
}
.l1{
    flex-basis: 100%;
    text-transform: uppercase;
    font-size: var(--menu-1-fontsize , 1.8rem);
    font-family: var(--menu-1-font, 'Arial', sans-serif);
    padding: 5px;
    border-width: var(--l1-border,0px 1px 0px 0px);
    /* transition: all 0.6s ease-in-out; */
}
.l1-activated{
    flex-basis: var(--l1-active-width,450px);
    flex-grow: 1;
}
.l2{
    /* flex-basis: var(--l2-width, 220px); */
    width: var(--l2-width);
    flex-grow: 0;
    font-size: var(--menu-2-fontsize , 1.2rem);
    font-family: var(--menu-2-font, 'Arial', sans-serif);
    padding: 5px;
    text-transform: uppercase;
    transition: all 0.6s ease-in-out;
    height: var(--l2-height);
    border-width: var(--l2-border,0px 1px 0px 0px);
}
.l2-activated{
    background-color:  var(--m-primary-color);
}
.filler{
    flex-grow: 1;
    /* transition: all 0.6s ease-in-out; */
}
.btn{
    border-style: solid;
    border-color: #fff;
    
    pointer-events: auto;
}
/* .lvl1 div:first-child {
    border-left: 1px solid #fff;
} */


</style>